module.exports = new __parcel__URL__("scratch01.74dde0b4.mp3").toString();